const strings = {
  'button/confirmPlayers/text': {
    en: `Submit picks`,
    fr: `Soumettre vos choix`,
  },
  'button/entered/text': {
    en: 'LOCK ICON',
    fr: 'LOCK ICON',
  },
  'button/submitted/text': {
    en: `Your picks are locked in—good luck! Check out the leaderboard after the game to see how you did.`,
    fr: `Vos choix sont enregistrés—bonne chance! Consultez le classement après le match pour voir vos résultats.`,
  },
  'button/submitAnswer/text': {
    en: `Submit Answer`,
    fr: `Soumettez votre réponse`,
  },
  'button/loadMore/text': {
    en: `Load More`,
    fr: `Charger plus`,
  },
  'button/submit/text': {
    en: `Submit`,
    fr: `Soumettre`,
  },
  'button/next/text': {
    en: `Next`,
    fr: `Suivant`,
  },
  'button/done/text': {
    en: `Done`,
    fr: `Terminé`,
  },
  'button/autoPicks/text': {
    en: 'Randomly select players',
    fr: 'Sélectionnez des joueurs au hasard',
  },
  'button/leaderboard/showPosition': {
    en: 'See your position',
    fr: 'Voir mon rang',
  },
  'button/leaderboard/scrollToTop': {
    en: 'Scroll to top',
    fr: 'Défiler vers le haut',
  },
  'button/heatstreak/panel1': {
    en: 'View Your NHL Regular Season Challenge Stats',
    fr: 'Consultez vos statistiques sur les défis de la saison régulière de la LNH',
  },
  'button/heatstreak/panel2': {
    en: 'View Your Monthly Challenge Stats',
    fr: 'Consultez les statistiques de vos défis mensuels',
  },
  'button/heatstreak/panel3': {
    en: 'View Your NHL Stanley Cup® Playoff Challenge Stats',
    fr: 'Consultez vos statistiques sur le défi des séries éliminatoires de la Coupe Stanley<sup>MC</sup> de la LNH',
  },
};

export default strings;
